export default "__VITE_PUBLIC_ASSET__2c9a5383__"